import React from 'react';
import S3Image from '../S3Image';

const Image = (): React.ReactElement => {
    return <S3Image file={'clients/client-nab-300x300.png'} />;
};

export default Image;
